module.exports = __webpack_public_path__ + "static/img/stamp.5f2a2ba.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/fifth/hk/stamp.png
// module id = NugB
// module chunks = 1 3